/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Tier admin list, editor, and priority modal.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../../common/app-shared.module';
import {TierEditPageComponent} from './tier-edit-page.component';
import {TierListPageComponent} from './tier-list-page.component';
import {TierRoutePageComponent} from './tier-route-page.component';
import {TierPriorityModalComponent} from './tier-priority-modal.component';

const TIER = [
  TierEditPageComponent,
  TierListPageComponent,
  TierRoutePageComponent,
  TierPriorityModalComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule
  ],
  declarations: TIER,
  exports: TIER
})
export class TierModule {
}
